<script>
export default {
    data() {
        return {
            clientId: "kh3yohkrwpbo6m71sryrw8hm0gls90",
            moderators: ["mepha", "warths"]
        }
    }
} 
</script>